import { signal } from "@preact/signals-react"

export const autoEuropeNotificationsListData = signal([])
export const autoEuropeNotificationsIsLoading = signal(false)

// Cascading selector source: nested pricing tool > reports > executions > offices.
export const autoEuropeCheckersData = signal([])
export const autoEuropeCheckersIsLoading = signal(false)